import { EmailItem } from "./EmailItem";
import { LocationType } from "./Enums";

export class LocationConfirmInfo {
    locationType: LocationType = LocationType.Origin;
    locCode: string = '';
    periodStartDate: string = '';
    periodEndDate: string = '';

    schedulePeriod: string = '';
    locations: EmailItem[] = [];
    internalContacts: EmailItem[] = [];

    locationId: number = 0;
    locationEmail: string = '';
    locationComments: string = '';
    internalComments: string = '';

    // options
    breakoutByDay: boolean = false;
    useDeliveryDate: boolean = false;
    showContract: boolean = false;
    showTrucker: boolean = false;
    showLocation: boolean = false;
    showCityState: boolean = false;
    showLoadNumber: boolean = false;
    showCustomer: boolean = false;
    hideUnassignedTrucker: boolean = false;
    showLoadNumbers: boolean = false;
    showDriverName: boolean = false;
    showPlateNumber: boolean = false;
}
